import { Checkbox, Dropdown, message, Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import svg from "../../../../Assets/svg";
import {
  ButtonWithLoader,
  PageLoader,
  SearchBar,
} from "../../../../Components/Components";
import {
  EditQuizAPI,
  GetQuestionsAPI,
  GetQuestionTypesAPI,
} from "../../../Redux/quiz";
import { useDispatch } from "react-redux";
import { AnswerTypesFilterOptions } from "../../QuestionBank/QuestionBank";

const ImportQuestionsModal = ({
  isModalOpen,
  onClose,
  quizId,
  questionsToPrefill,
}) => {
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(true);

  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);

  const [data, setData] = useState([]);
  const [fetchKey, setFetchKey] = useState(0);
  const [totalCount, setTotalCount] = useState();
  const [page, setPage] = useState(1);
  const limit = 10;
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState([]);
  const [selectedAnswerType, setSelectedAnswerType] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [filterCachedData, setFilterCachedData] = useState(null);
  const [filterSearch, setFilterSearch] = useState("");
  const [questionTypeOptions, setQuestionTypeOptions] = useState([]);

  const [expandedQuestions, setExpandedQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState(
    questionsToPrefill?.length > 0 ? questionsToPrefill : []
  );

  const fetchQuestions = async () => {
    if (page === 1) {
      setLoading(true);
    }
    setFetching(true);
    const result = await dispatch(
      GetQuestionsAPI({
        page: page,
        limit: limit,
        search: debouncedSearchValue,
        questionType: selectedQuestionType,
        answerType: selectedAnswerType,
      })
    );
    if (result?.success) {
      setTotalCount(result.data.total);
      // setData(result.data.data);
      setData((prev) =>
        page === 1 ? result.data.data : [...prev, ...result.data.data]
      );
    }
    setFetching(false);
    if (page === 1) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, [page, fetchKey]);

  const refetchDataHandler = () => {
    setPage(1);
    setFetchKey((prev) => prev + 1);
    // fetchQuestions();
  };

  const fetchQuestionTypes = async () => {
    // setFetching(true);
    const result = await dispatch(GetQuestionTypesAPI());
    if (result?.success) {
      setQuestionTypeOptions(result.data.map((i) => ({ value: i, label: i })));
    }
    // setFetching(false);
  };

  useEffect(() => {
    fetchQuestionTypes();
  }, []);

  useEffect(() => {
    if (searchValue === "") {
      setDebouncedSearchValue("");
      refetchDataHandler();
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
      refetchDataHandler();
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const handleApplyFilter = () => {
    setFilterCount(selectedAnswerType?.length + selectedQuestionType?.length);
    setFilterCachedData({
      ...filterCachedData,
      selectedAnswerType,
      selectedQuestionType,
    });
    setIsFilterVisible((prev) => !prev);
    refetchDataHandler();
  };

  const menu = (
    <>
      <div className="card filterDropdownCard border-0 rounded-4 shadow overflow-hidden ff">
        <div className="card-body p-0">
          <div className="row gx-0">
            <div className="col-md-4">
              <div className="d-flex flex-column h-100">
                <div className="filter-header border-bottom border-end px-4 py-2">
                  <h5 className="fs-5 fw-semibold text-black mb-0 ff">
                    Filters
                  </h5>
                </div>
                <div className="filter-body border-end p-3 h-100">
                  <ul className="list-unstyled mb-0">
                    <li
                      onClick={() => {
                        setActiveTabKey("1");
                      }}
                    >
                      <div
                        className={`ff btn btn-link filter-tab-link fw-semibold fs-6 text-decoration-none text-start w-100 ${
                          activeTabKey === "1" ? "active" : ""
                        } ${
                          selectedAnswerType?.length > 0
                            ? "active-filter-tab"
                            : ""
                        }
                        `}
                      >
                        Answer Type
                      </div>
                    </li>
                    <li
                      onClick={() => {
                        setActiveTabKey("2");
                      }}
                    >
                      <div
                        className={`ff btn btn-link filter-tab-link fw-semibold fs-6 text-decoration-none text-start w-100 ${
                          activeTabKey === "2" ? "active" : ""
                        } ${
                          selectedQuestionType?.length > 0
                            ? "active-filter-tab"
                            : ""
                        }
                        `}
                      >
                        Question Type
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="d-flex flex-column h-100">
                {/* {activeTabKey === "1" && ( */}
                <div className="filter-header border-bottom border-end px-2 py-2">
                  <div className="filter-search position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={filterSearch}
                      onChange={(e) => setFilterSearch(e?.target?.value)}
                    />
                    <span className="ff svg-14 position-absolute top-50 end-0 translate-middle-y me-3">
                      {svg.search}
                    </span>
                  </div>
                </div>
                {/* )} */}
                <div className="filter-body border-end p-3 h-100">
                  <ul className="list-unstyled mb-0">
                    {activeTabKey === "1" &&
                      AnswerTypesFilterOptions?.filter((elem) =>
                        elem?.label
                          ?.toLowerCase()
                          .includes(filterSearch?.toLowerCase())
                      )?.map((elem) => {
                        return (
                          <li key={elem?._id}>
                            <div className="custom-filter-checkbox mb-2">
                              <input
                                type="checkbox"
                                id={elem?.value}
                                checked={selectedAnswerType?.includes(
                                  elem?.value
                                )}
                                onChange={(e) => {
                                  const isChecked = e?.target?.checked;
                                  if (isChecked) {
                                    setSelectedAnswerType((prev) => [
                                      ...prev,
                                      elem?.value,
                                    ]);
                                  } else {
                                    setSelectedAnswerType((prev) =>
                                      prev?.filter(
                                        (comp) => comp !== elem?.value
                                      )
                                    );
                                  }
                                }}
                              />
                              <label
                                htmlFor={elem?.value}
                                className="ff d-inline-flex align-item-center fs-6 text-black"
                              >
                                <span className="svg-16 me-2">
                                  {svg.filterCheckbox}
                                </span>{" "}
                                {elem?.label}
                              </label>
                            </div>
                          </li>
                        );
                      })}
                    {activeTabKey === "2" &&
                      questionTypeOptions
                        ?.filter((elem) =>
                          elem?.label
                            ?.toLowerCase()
                            .includes(filterSearch?.toLowerCase())
                        )
                        ?.map((elem) => {
                          return (
                            <li key={elem?._id}>
                              <div className="custom-filter-checkbox mb-2">
                                <input
                                  type="checkbox"
                                  id={elem?.value}
                                  checked={selectedQuestionType?.includes(
                                    elem?.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e?.target?.checked;
                                    if (isChecked) {
                                      setSelectedQuestionType((prev) => [
                                        ...prev,
                                        elem?.value,
                                      ]);
                                    } else {
                                      setSelectedQuestionType((prev) =>
                                        prev?.filter(
                                          (comp) => comp !== elem?.value
                                        )
                                      );
                                    }
                                  }}
                                />
                                <label
                                  htmlFor={elem?.value}
                                  className="ff d-inline-flex align-item-center fs-6 text-black"
                                >
                                  <span className="svg-16 me-2">
                                    {svg.filterCheckbox}
                                  </span>{" "}
                                  {elem?.label}
                                </label>
                              </div>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="d-flex flex-column h-100">
                <div className="filter-header border-bottom px-2 py-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="ff mb-0 fw-semibold fs-7">
                      Selected (
                      {selectedAnswerType?.length +
                        selectedQuestionType?.length}
                      )
                    </p>
                    <div
                      onClick={() => {
                        setSelectedAnswerType([]);
                        setSelectedQuestionType([]);
                      }}
                      className="text-danger fw-medium fs-7 d-inline-block me-3 cursor-pointer"
                    >
                      Clear All
                    </div>
                  </div>
                </div>
                <div className="filter-body p-3 h-100">
                  <ul className="list-unstyled filterCheckedList mb-0">
                    {selectedAnswerType?.map((elem) => {
                      return (
                        <li key={elem}>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <label className="d-inline-flex align-item-center fs-6 text-black">
                              <span className="svg-16 checkedSvg me-2">
                                {svg.filterCheckbox}
                              </span>{" "}
                              {AnswerTypesFilterOptions?.find(
                                (cat) => cat?.value === elem
                              )?.label || ""}
                            </label>
                            <div
                              onClick={() => {
                                setSelectedAnswerType((prev) =>
                                  prev?.filter((comp) => comp !== elem)
                                );
                              }}
                              className="svg-16 d-inline-block"
                            >
                              {svg.filterCrossIcon}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                    {selectedQuestionType?.map((elem) => {
                      return (
                        <li key={elem}>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <label className="d-inline-flex align-item-center fs-6 text-black">
                              <span className="svg-16 checkedSvg me-2">
                                {svg.filterCheckbox}
                              </span>{" "}
                              {questionTypeOptions?.find(
                                (cat) => cat?.value === elem
                              )?.label || ""}
                            </label>
                            <div
                              onClick={() => {
                                setSelectedQuestionType((prev) =>
                                  prev?.filter((comp) => comp !== elem)
                                );
                              }}
                              className="svg-16 d-inline-block"
                            >
                              {svg.filterCrossIcon}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer d-flex justify-content-end align-items-center gap-3 border-top-0 bg-white shadow">
          <div
            // href="#"
            className="fw-medium text-muted fs-6 cursor-pointer"
            onClick={() => {
              setActiveTabKey("1");
              setFilterSearch("");
              setIsFilterVisible(false);
            }}
          >
            Cancel
          </div>
          <button
            className="btn text-white px-3"
            onClick={() => {
              handleApplyFilter();
            }}
            style={{
              backgroundColor: "#E58344",
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </>
  );

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 100;

    if (bottom && !fetching && data.length < totalCount) {
      setPage((prev) => prev + 1);
      setFetching(true);
    }
  };

  const handleSave = () => {
    if (selectedQuestions.length === 0) {
      message.error("Please select at least one question");
      return;
    }

    const payload = {
      quiz_id: quizId,
      questions: selectedQuestions,
    };

    setSaving(true);
    dispatch(
      EditQuizAPI(
        payload,
        () => {
          setSaving(false);
          onClose(true);
        },
        () => {
          setSaving(false);
        }
      )
    );
  };

  return (
    <Modal
      title={
        <div className="modal-header border-bottom pb-2 ">
          <div className="fw-bold fs-4 ff">
            Import Questions From Question Bank{" "}
            {totalCount > 0 && `(${totalCount})`}
          </div>
          {selectedQuestions.length > 0 && (
            <div className="fs-6 ff text-green">
              {selectedQuestions.length} Questions Selected
            </div>
          )}
        </div>
      }
      open={isModalOpen}
      onCancel={() => onClose()}
      footer={
        loading ? null : (
          <div className="d-flex justify-content-center align-items-center">
            <ButtonWithLoader
              className="btn btn-primary btn-lg ku-btn px-4 ff"
              onClick={handleSave}
              isLoading={saving}
            >
              Save
            </ButtonWithLoader>
          </div>
        )
      }
      centered
      closeIcon={svg?.modalClose}
      className="custom-modal"
      width={"67.5rem"}
      maskClosable={false}
    >
      {loading ? (
        <div className="d-flex justify-content-center align-items-center px-5 py-5">
          <PageLoader />
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
          <div className="d-flex align-items-center justify-content-between gap-2 ">
            <SearchBar
              value={searchValue}
              setValue={setSearchValue}
              searchHandler={(e) => setSearchValue(e.target.value)}
              placeholder={"Search"}
              inputClass={"border-25 ps-5 border"}
              clearData={() => setSearchValue("")}
              isLarge
            />
            <div className="d-flex gap-md-3 gap-2">
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                open={isFilterVisible}
                onOpenChange={(visible) => setIsFilterVisible(visible)}
                placement="topRight"
                className="cursor-pointer"
                overlayClassName="filterDropdown"
              >
                <Tooltip title={"Filters"}>
                  <div
                    className="svg-btn svg-50 svg-outline-secondary position-relative cursor-pointer"
                    onClick={() => {
                      setActiveTabKey("1");
                      setIsFilterVisible(true);
                      if (filterCachedData) {
                        setSelectedAnswerType(
                          filterCachedData.selectedAnswerType
                        );
                        setSelectedQuestionType(
                          filterCachedData.selectedQuestionType
                        );
                      }
                    }}
                  >
                    {svg.filterButton}
                    <span className="badge filter-badge position-absolute bg-danger">
                      {filterCount > 0 ? filterCount : ""}
                    </span>
                  </div>
                </Tooltip>
              </Dropdown>
            </div>
          </div>
          <div className="questionsContainer" onScroll={handleScroll}>
            {data?.length > 0 &&
              data?.map((item) => {
                const isExpanded = expandedQuestions.includes(item._id);
                return (
                  <div
                    className="d-flex align-items-center gap-2 mb-2"
                    key={item._id}
                  >
                    <div>
                      <Checkbox
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedQuestions((prev) => [...prev, item._id]);
                          } else {
                            setSelectedQuestions((prev) =>
                              prev.filter((id) => id !== item._id)
                            );
                          }
                        }}
                        checked={selectedQuestions.includes(item._id)}
                        className="fs-5 text-black questionSelection"
                      />
                    </div>
                    <div className="d-flex flex-column w-100 questionItemWrapper">
                      <div
                        className={`d-flex align-items-center w-100 ${
                          isExpanded ? "question-list-header border-bottom" : ""
                        } `}
                      >
                        <div className="question-list-title fs-6 fw-bold ff">
                          {item?.question}
                        </div>
                        <div className="ms-auto d-flex gap-2">
                          <div
                            className={`${
                              item?.ans_type === "text"
                                ? "text-green"
                                : "text-orange"
                            }  fs-6 fw-bold ff`}
                          >
                            {item?.ans_type === "text"
                              ? "Text Area"
                              : "Multiple Choice"}
                          </div>
                          <div
                            className="cursor-pointer"
                            style={{
                              visibility:
                                item?.ans_type === "text"
                                  ? "hidden"
                                  : "visible",
                            }}
                            onClick={() => {
                              if (isExpanded) {
                                setExpandedQuestions((prev) =>
                                  prev.filter((id) => id !== item._id)
                                );
                              } else {
                                setExpandedQuestions((prev) => [
                                  ...prev,
                                  item._id,
                                ]);
                              }
                            }}
                          >
                            {isExpanded ? svg.collapseIcon : svg.expandIcon}
                          </div>
                        </div>
                      </div>

                      {isExpanded && item?.options?.length > 0 && (
                        <>
                          <div className="row">
                            {item?.options?.map((opt) => {
                              return (
                                <div className="col-3">
                                  <div className="answerOption d-flex justify-content-between align-items-center">
                                    <span className="fs-6">
                                      {opt?.text ? opt?.text : "-"}
                                    </span>
                                    {opt.is_correct && (
                                      <span className="svg-22 d-inline-block me-3 lh-0">
                                        {svg?.correctOption}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <div>
                            <label className="ff fs-6 fw-bold">
                              Reflection:
                            </label>{" "}
                            <span className="ff fs-6">
                              {item?.reflection ? item?.reflection : "-"}
                            </span>
                          </div>
                          <div>
                            <label className="ff fs-6 fw-bold">
                              Reference:
                            </label>{" "}
                            <span className="ff fs-6">
                              {item?.ay_reflection ? item?.ay_reflection : "-"}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ImportQuestionsModal;
